(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardDialogController', KiosksDashboardDialogController);

    KiosksDashboardDialogController.$inject = ['$state', '$timeout', '$scope', 'KiosksDashboards', 'TabDomains', 'pagingParams', 'entity'];

    function KiosksDashboardDialogController($state, $timeout, $scope, KiosksDashboards, TabDomains, pagingParams, entity) {
        var vm = this;
        vm.kiosksDashboard = entity;
        vm.domains = TabDomains.query({size: 1000});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:kiosksDashboardUpdate', result);
            vm.isSaving = false;
            $state.go('kiosks-dashboard');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.kiosksDashboard.id) {
                KiosksDashboards.update(vm.kiosksDashboard, onSaveSuccess, onSaveError);
            } else {
                KiosksDashboards.save(vm.kiosksDashboard, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('kiosks-dashboard');
        };

        vm.setGrafanaId = function () {
            vm.kiosksDashboard.grafanaId = vm.dashboard.id;
            vm.kiosksDashboard.name = vm.dashboard.title;
        }

        if(pagingParams.registeredDashboard) {
            vm.enableSelect = true;
            KiosksDashboards.availableDashboard(function (result) {
                vm.grafanaDashboard = result;
                pagingParams.registeredDashboard.forEach(function (dash) {
                    vm.grafanaDashboard.splice(dash, 1);
                })
            });
        }  else {
            vm.enableSelect = false;
            vm.dashboard = vm.kiosksDashboard;
        }

    }
})();
